<template>
  <div>
    <sweet-modal ref="modal" overlay-theme="dark">
      <div v-if="!success">
        <p class="text-center">
          <i class="fas fa-info-circle fa-2x" style="color: #7ac29a;"></i>
        </p>
        <h5 class="info-text m-t-0-i p-t-0-i">Your Details</h5>
        <form @submit.prevent="sendQuote">
          <div class="form-group">
            <label>
              Email
              <span class="required-field">*</span>
            </label>
            <input type="text" v-model="email" class="form-control" />
          </div>

          <div class="form-group">
            <label>
              Full Name
              <span class="required-field">*</span>
            </label>
            <input type="text" v-model="fullName" class="form-control" />
          </div>

          <div class="form-group">
            <label>
              Business Name
              <span class="required-field">*</span>
            </label>
            <input type="text" v-model="businessName" class="form-control" />
          </div>

          <div class="form-group">
            <label>
              Date Of Birth
              <span class="required-field">*</span>
            </label>
            <datetime
              type="date"
              :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
              width="100%"
              v-model="dateOfBirth"
              class="form-control"
              zone="Australia/Brisbane"
            ></datetime>
          </div>

          <div class="form-group">
            <label>
              Phone Number
              <span class="required-field">*</span>
            </label>
            <input type="text" v-model="phoneNumber" class="form-control" />
          </div>

          <div class="form-group">
            <label>
              Gender
              <span class="required-field">*</span>
            </label>
            <br />
            <div class="btn-group push-15 btn-group-justified">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-sm b-r-0"
                  :class="{ 'btn-selected btn-fill' : gender == 'male'}"
                  @click="gender = 'male'"
                >Male</button>
              </div>
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="{ 'btn-selected btn-fill' : gender == 'female'}"
                  @click="gender = 'female'"
                >Female</button>
              </div>
            </div>
          </div>
        </form>

        <button
          class="btn btn-next btn-fill btn-success btn-block btn-wd"
          :disabled="!enabled"
          @click.prevent="sendQuote"
          v-if="!loading"
        >Email My Quote</button>
        <button class="btn btn-next btn-fill btn-success btn-block btn-wd" disabled v-else>
          <i class="fa fa-spinner fa-spin"></i> Processing...
        </button>
      </div>

      <div class="alert alert-success m-t-35 m-b-0-i" v-else>
        <strong>Success!</strong>
        <p>Your quote has been sent to your email!</p>
      </div>

      <div class="alert alert-danger m-t-35 m-b-0-i" v-if="error">
        <strong>There was an error.</strong>
        <p>Unfortunately, we were unable to process this request. Please try again later.</p>
      </div>
    </sweet-modal>

    <button
      class="btn btn-next btn-fill btn-success btn-wd btn-block"
      @click.prevent="triggerPopup"
    >
      <i class="fa fa-envelope"></i> Email This Quote
    </button>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import { mapState } from "vuex";
import { isEmpty } from "lodash";
import cookie from "js-cookie";
import { apiDomain } from "../configs";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Datetime
  },

  watch: {
    pendingOrder(pendingOrder) {
      this.setPendingOrderDetails(pendingOrder);
    }
  },

  mounted() {
    this.fetchPendingOrder();
  },

  data() {
    return {
      pendingOrder: {},
      email: "",
      fullName: "",
      businessName: "",
      dateOfBirth: "",
      phoneNumber: "",
      gender: "",
      loading: false,
      success: false,
      error: false
    };
  },

  computed: {
    pendingOrderId() {
      return cookie.get("pendingOrderId");
    },

    enabled() {
      return (
        this.email &&
        this.fullName &&
        this.businessName &&
        this.dateOfBirth &&
        this.phoneNumber &&
        this.gender
      );
    }
  },

  methods: {
    sendQuote() {
      let data = {
        email: this.email,
        name: this.fullName,
        business_name: this.businessName,
        dob: this.dateOfBirth,
        phone: this.phoneNumber,
        gender: this.gender
      };

      this.loading = !this.loading;

      axios
        .post(`${apiDomain}/form/email-quote/${this.pendingOrderId}`, data)
        .then(res => {
          this.loading = !this.loading;
          if (res.status === 200) {
            this.success = true;
          }
        })
        .catch(err => {
          this.loading = !this.loading;
          if (err) {
            this.error = err;
          }
        });
    },

    fetchPendingOrder() {
      axios
        .get(`${apiDomain}/form/get-pending-order/${this.pendingOrderId}`)
        .then(res => {
          this.pendingOrder = res.data;
        });
    },

    setPendingOrderDetails(pendingOrder) {
      this.email = pendingOrder.email;
      this.fullName = pendingOrder.name;
      this.businessName = pendingOrder.business_name;
      this.dateOfBirth = pendingOrder.dob;
      this.gender = pendingOrder.gender;
      this.phoneNumber = pendingOrder.phone;
    },

    triggerPopup() {
      this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss">
@import "../../sass/form/sweetalert";

.sweet-modal {
  border-radius: 6px !important;
}
.sweet-modal.is-alert .sweet-content {
  text-align: left !important;
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.sweet-modal .sweet-box-actions .sweet-action-close:hover {
  background: #7ac29a !important;
}
.vdatetime-input {
  width: 100% !important;
  border: 0px !important;
  background: transparent !important;
}
.vdatetime-popup__header {
  background: #009245 !important;
}
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  background: #009245 !important;
}
.vdatetime-popup__actions__button {
  color: #009245 !important;
}
.vdatetime-year-picker__item--selected {
  color: #009245 !important;
}
</style>
